import React, { useEffect, useState } from 'react';
import Card from './card'; 

import { Swiper, SwiperSlide } from 'swiper/react'; 
import { Navigation, Pagination } from 'swiper/modules'; 

import 'swiper/css';
import 'swiper/css/navigation'; 
import 'swiper/css/pagination'; 

function Products() {
    const [products, setProducts] = useState([]);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const res = await fetch('/data/products.json');
                const data = await res.json();
                setProducts(data);
            } catch (err) {
                console.error(err);
            }
        };
        fetchProducts();
    }, []);

    const swiperParams = {
        modules: [Navigation, Pagination],
        slidesPerView: 2, 
        spaceBetween: 30, 
        
        navigation: true, 
        pagination: { 
            clickable: true 
        }, 
        
        slidesPerGroup: 2, 
        loop: false, 
    };

    return (
        <div className='flex flex-col items-center px-4 py-8'>

            <h3 className='text-[var(--primary)] text-center text-4xl font-extrabold font-ibmArabic mb-6'

            >
                تعرف على منتجاتنا
            </h3>

            {products.length === 0 ? (
                <p> No products To Show </p>
            ) : (
                <div className="w-full max-w-4xl"> 
                    <Swiper {...swiperParams}>
                        {products.map((product) => (
                            <SwiperSlide key={product.id}>
                                <div className="flex justify-center h-full">
                                    <Card
                                        details={product.name}
                                        image={product.picture}
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            )}
        </div>
    );
}

export default Products;